import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';

import reportWebVitals from './reportWebVitals';

import { App } from 'app';
import { store } from 'state';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

reportWebVitals();
